/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import { useParams } from 'umi';
import { getFilterConfig } from '../utils';

export interface IKpiTrendServiceProps
  extends BaseServiceComponentProps {
  metric: string;
  [key: string]: any;
}

export default function KpiTrendService(
  props: IKpiTrendServiceProps,
) {
  const {
    style,
    className,
    dataKey = 'revenueTrendData',
    api,
    children,
    filter,
    tabFilter,
    extraParams = {},
    formatData: propsFormatData,
    data: propsData,
    changeData,
    filterConfig,
    ...restProps
  } = props || {};

  const filterVal = useMemo(() => ({ ...tabFilter, ...filter }), [tabFilter, filter]);

  const { studioId } = useParams() || {} as any;
  const formatData = (data: any) => {
    if (propsFormatData && typeof propsFormatData === 'function') return propsFormatData?.(data);
    return data || {};
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={{ ...(propsData || {}) }}
        dataKey={dataKey}
        filterLoading={!tabFilter?.date}
        formatData={formatData}
        filterVal={filterVal}
        trackData={["changeDataItem"]}
        beforeRequest={(data) => {
          const { filterVal ,changeDataItem} = data;
          const { date, date_type: dateType, selectorList, payType } = filterVal || {};
          const { selectedGame,selectedSegment } = changeDataItem || {};
          const { gameCodes, filterChangeParams } = selectedGame || {};
          const { filteredList, value} = selectedSegment || {};
          const params = {
            studio_code: studioId,
            game_codes: gameCodes,
            period: dateType || "daily",
            start_time: date,
            end_time: date,
            metrics: [value],
            filters: {
              zone_list: ['255'],
              market_list: ['255'],
              channel_list: ['255'],
              os_list: ['255'],
              category_list: ['255'],
              product_list: ['255'],
              ...(filterChangeParams || {}),
            },
            ...extraParams
          };
          // 筛选器过滤
          if(filterConfig){
            const processedFilters = getFilterConfig(selectorList, filterConfig, filterChangeParams);
            params.filters = processedFilters;
          }  
          if (payType) {
            // 增加筛选器参数
            params.filters.custom_filters = [
              {
                key: 'payment_type',
                filter_list: [filteredList],
              },
            ];
          }
          return params;
        }}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(restProps || {}),
            ...(propsData || {}),
            dataKey,
            changeData,
            filter,
            tabFilter
          }),
        )}
      </Service>
    </div>
  );
}
